import { Grid } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'next-i18next';
import config from 'src/config';

import QualityCourseSectionStyle from './style';

import Image from '@components/atoms/image';

const QualityCourseSection = () => {
  const { t } = useTranslation('common');

  return (
    <QualityCourseSectionStyle>
      <Box className="container">
        <Grid container item xs={12} xl={12} spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={5} xl={5} className="quality-course-col1">
            <Typography color="#164843" variant="h1" className="topic">
              {t('cpd_landing.quality.course.title')}
            </Typography>
            <Typography color="rgba(0, 0, 0, 0.6)" variant="h4" className="sub-topic">
              {t('cpd_landing.quality.course.description')}
            </Typography>
          </Grid>
          <Grid item xs={0} sm={0} md={0} lg={1} xl={1} />
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6} className="quality-course-col2">
            <Box className="logo-group">
              {/* TODO: Waiting for CPD TII Business confirming */}
              {/* <Box className="logo-tii">
                <Image
                  alt={t('cpd.common.tii')}
                  src={`${config.IMAGE_CDN_HOST}/assets/cpd-landing/TII-new-Logo@2x.png`}
                />
              </Box> */}
              <Box className="logo-tip">
                <Image
                  alt={t('cpd.common.tip')}
                  src={`${config.IMAGE_CDN_HOST}/assets/cpd-landing/TIP-Logo.png`}
                  srcSet={`${config.IMAGE_CDN_HOST}/assets/cpd-landing/TIP-Logo.png, ${config.IMAGE_CDN_HOST}/assets/cpd-landing/TIP-Logo@2x.png 2x`}
                  srcSetWebp={`${config.IMAGE_CDN_HOST}/assets/cpd-landing/TIP-Logo.webp, ${config.IMAGE_CDN_HOST}/assets/cpd-landing/TIP-Logo@2x.webp 2x`}
                />
              </Box>
              <Box className="logo-skilllanecpd">
                <Image
                  alt={t('cpd_landing.overview.title')}
                  src={`${config.IMAGE_CDN_HOST}/assets/cpd-landing/LogoCPD.svg`}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </QualityCourseSectionStyle>
  );
};

export default QualityCourseSection;
